import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { formatDateOnly } from '../../../../../utils/dateUtils';

const ApprovalHistoryDialog = ({ visible, onHide, selectedItem = null, useGetByIdQuery }) => {
    const { th } = useLanguage();

    const [historyData, setHistoryData] = useState({
        createdName: '',
        createdDate: '',
        modifiedName: '',
        modifiedDate: ''
    });

    const { data: itemDetails, isLoading: isLoadingDetails } = useGetByIdQuery(selectedItem?.id, { skip: !selectedItem?.id || !visible });

    useEffect(() => {
        if (visible && itemDetails) {
            setHistoryData({
                createdName: itemDetails.createdName || '',
                createdDate: itemDetails.createdDate || '',
                modifiedName: itemDetails.modifiedName || '',
                modifiedDate: itemDetails.modifiedDate || ''
            });
        } else if (!visible) {
            setHistoryData({
                createdName: '',
                createdDate: '',
                modifiedName: '',
                modifiedDate: ''
            });
        }
    }, [visible, itemDetails]);

    const footer = (
        <div className="flex justify-content-end">
            <Button label={th('common.close')} icon="pi pi-times" outlined onClick={onHide} />
        </div>
    );

    return (
        <Dialog visible={visible} style={{ width: '90vw', maxWidth: '650px' }} header={th('common.history')} modal className="p-fluid" footer={footer} onHide={onHide} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
            <div className="p-fluid">
                <div className="grid">
                    <div className="col-6">
                        <div className="field">
                            <label htmlFor="createdName" className="font-bold">
                                {th('common.created')}
                            </label>
                            <InputText id="createdName" value={historyData.createdName} disabled={true} loading={isLoadingDetails} />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="field">
                            <label htmlFor="createdDate" className="font-bold">
                                {th('common.createdDate')}
                            </label>
                            <InputText id="createdDate" value={formatDateOnly(historyData.createdDate)} disabled={true} loading={isLoadingDetails} />
                        </div>
                    </div>
                </div>

                <div className="grid mt-3">
                    <div className="col-6">
                        <div className="field">
                            <label htmlFor="modifiedName" className="font-bold">
                                {th('common.updatedBy')}
                            </label>
                            <InputText id="modifiedName" value={historyData.modifiedName} disabled={true} loading={isLoadingDetails} />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="field">
                            <label htmlFor="modifiedDate" className="font-bold">
                                {th('common.updatedDate')}
                            </label>
                            <InputText id="modifiedDate" value={formatDateOnly(historyData.modifiedDate)} disabled={true} loading={isLoadingDetails} />
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default ApprovalHistoryDialog;
